import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { AutomaticMessageActionTypes } from "./AutomaticMessage.type";

export function* fetchAllAutomaticMessages(action: any): any {
  try {
    let query = "";

    if (action.payload && Object.keys(action.payload).length > 0) {
      query = `?${Object.keys(action.payload)
        .map((key) => `${key}=${action.payload[key]}`)
        .join("&")}`;
    }

    const response = yield axios.get(
      `${API_BASE_URI}/automatic-message?${query}`
    );
    yield put({
      type: AutomaticMessageActionTypes.FETCH_ALL_AUTOMATIC_MESSAGE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: AutomaticMessageActionTypes.FETCH_ALL_AUTOMATIC_MESSAGE_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneAutomaticMessages(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/automatic-message/${action.payload}`
    );
    yield put({
      type: AutomaticMessageActionTypes.FETCH_ONE_AUTOMATIC_MESSAGE_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: AutomaticMessageActionTypes.FETCH_ONE_AUTOMATIC_MESSAGE_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllAutomaticMessages() {
  yield takeLatest(
    AutomaticMessageActionTypes.FETCH_ALL_AUTOMATIC_MESSAGE,
    fetchAllAutomaticMessages
  );
}

export function* watcherFetchOneAutomaticMessages() {
  yield takeLatest(
    AutomaticMessageActionTypes.FETCH_ONE_AUTOMATIC_MESSAGE,
    fetchOneAutomaticMessages
  );
}
